import { CacheLocation } from "@auth0/auth0-spa-js/src/global";

export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  cacheLocation: "localstorage" as CacheLocation,
};
